import { SystemsDecorator } from "../../modules/systems";
import { Orders } from "./Orders";

export const OrdersContainer = () => {
  return (
    <SystemsDecorator>
      {(system) => {
        return <Orders siteId={system.siteId} />;
      }}
    </SystemsDecorator>
  );
};
